"use strict";
/**
 * <h4>Send track user events<h4/>
 *
 * The Tracker module is responsible for transmitting user event tracking data. <br/>
 * A customer account configuration is required for use. The methods should be executed when the appropriate event occurs.<br/>
 * It is very important to send correct data because system Qon uses it to wyznaczania products in recommendations frames.
 * @packageDocumentation
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = exports.Tracker = void 0;
var TrackerImpl_1 = require("./TrackerImpl");
Object.defineProperty(exports, "Tracker", { enumerable: true, get: function () { return TrackerImpl_1.TrackerImpl; } });
/** @module */
exports.Error = require("./IO/Output/Error/");
//# sourceMappingURL=index.js.map